"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-x-8 gap-y-4">
        {[1, 2, 3, 4, 5].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-[14px] uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
          {item.label}
        </Link>)}
    </nav>;
}
export default function RodapeInstitucional() {
  return <section id="rodapé-institucional" className="dark bg-background text-foreground border-t border-border py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
        <MenuProvider menu_id="17">
          <FooterMenuConsumer />
        </MenuProvider>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[14px]">
          <p className="text-foreground/80">
            Copyright &copy; 2026 Linx Vila Velha
          </p>
          <p className="text-foreground/80">
            Powered by Linx Vila Velha
          </p>
        </div>
      </div>
    </section>;
}